'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();

import { usePathname } from 'next/navigation';
import { NProgressBar } from 'shared/components/NProgressBar';

export default function ProgressBar() {
  const pathname = usePathname();
  return <NProgressBar pathname={pathname} />;
}
